import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import _ from 'lodash';
import SalesCatalystTargetMarketInput from '../SalesCatalystTargetMarket/SalesCatalystTargetMarketInput';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import SalesCatalystBoxInput from '../../common/SalesCatalystBoxInput';
import addButton from '../../../images/salescatalyst/AddIcon.png';
import closeButton from '../../../images/salescatalyst/CloseIcon.png';
import { getBackGroundColor, getTextColor, formCategoryData } from '../../../util/SalesCatalystUtils';
import { SALES_CATALYST_MEDIA_PACKAGE,
  SALES_CATALYST_HEADERINFO_REPORT_NAME,
} from '../../../constants';


class SalesCatalystMediaPackageInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      async_test: undefined,
      showBrandSearchBox: false,
      renderInitialScreen: props.renderInitialScreen,
    };
  }
  componentDidMount() {
    if (this.props.dataSelection.brand.length === 1 &&
       _.isEmpty(this.props.dataSelection.category)) {
      this.props.fetchBrandCategory(this.props.dataSelection.brand[0]);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.dataSelection.brand.length === 0 &&
      nextProps.dataSelection.brand.length === 1 &&
      _.isEmpty(this.props.dataSelection.category)) {
      this.props.fetchBrandCategory(nextProps.dataSelection.brand[0]);
    } else if (this.props.loadMediaPackageGarph !== nextProps.loadMediaPackageGarph &&
      this.props.dataSelection.brand.length === 1 &&
       _.isEmpty(this.props.dataSelection.category)) {
      this.props.fetchBrandCategory(nextProps.dataSelection.brand[0]);
    }
    if (this.props.dataSelection.brand.length === 1 &&
      nextProps.dataSelection.brand.length === 0) {
      this.setState({
        renderInitialScreen: true,
      });
    }
    if (this.props.dataSelection.brand.length === 0 &&
      nextProps.dataSelection.brand.length === 1) {
      this.setState({
        renderInitialScreen: false,
      });
    }
  }

  onBrandSelect = brand => {
    if (typeof (brand) === 'object' && !_.isEmpty(brand)) {
      this.setState({
        renderInitialScreen: false,
        showBrandSearchBox: false,
      },
      () => { this.props.fetchBrandDetails(brand); }
      );
    }
  }

  getOptions = (input, callback) => {
    let options = [];
    if (input.length > 2) {
      const promise = new Promise(resolve => {
        this.props.searchBrand(input, resolve);
      });
      promise.then(brandList => {
        options = brandList.data.map(brand =>
          ({ value: brand.keyword, label: brand.label }));
        callback(null, { options });
      });
    } else {
      callback(null, { options });
    }
  }

  deleteHandler = (field, subCategory) => {
    this.props.deleteSalasCatalystSelection(field, subCategory, SALES_CATALYST_MEDIA_PACKAGE);
  }

  toggleBrandSearchBox = (showBrandSearchBox = true, renderInitialScreen = false) => {
    this.setState({
      showBrandSearchBox,
      renderInitialScreen,
    });
  }

  renderBrandSerachBox = () => {
    return (
      <div className="large-12 medium-12 small-12 columns" style={{ paddingTop: '1%' }}>
        <div className="large-3 medium-3 small-3 columns" style={{ width: '21%' }}>
          <span className="target-market-label">Brand:</span>
        </div>
        <div className="large-6 medium-6 small-6 columns brand-search-box">
          <Select.Async
            name="form-field-name"
            placeholder={'Enter Brand Name'}
            multi={false}
            value={this.state.async_test}
            loadOptions={this.getOptions}
            onBlurResetsInput={false}
            cache={false}
            noResultsText={'No result found'}
            clearable
            onChange={e => this.onBrandSelect(e)}
          />
        </div>
        <div>
          <button
            className="cancelButton"
            onClick={() => {
              this.toggleBrandSearchBox(false, true);
            }}
          >
            <img src={closeButton} alt="Close Brand" title="Close Brand" />
          </button>
        </div>

      </div>
    );
  }

  renderComponentWithOutCategory= (dataSelection, dataOnScreen) => {
    return (
      <SalesCatalystTargetMarketInput
        color={this.props.color}
        className={'large-3 medium-3 small-3 columns'}
      >
        <div className="large-3 medium-3 small-3 columns">
          <SalesCatalystBoxInput
            defaultHeader={'BRAND'}
            data={dataSelection.brand[0]}
            deleteHandler={this.deleteHandler}
            subCategory={'brand'}
            field={'dataSelection'}
            index={0}
            backgroundColor={getBackGroundColor(dataSelection.brand[0],
              dataOnScreen.mediaPackage, 'BRAND')}
            color={getTextColor(dataSelection.brand[0],
              dataOnScreen.mediaPackage)}
            dataOnScreen={dataOnScreen.mediaPackage}
            clickEventFunction={this.toggleBrandSearchBox}
            showEditButton={false}
            showClickableBoxInput
            clickBoxDefaultTitle={'ADD BRAND'}
          >
            <div>
              <button
                className="addButton"
              >
                <img className="brandAddButton" src={addButton} alt="ADD BRAND" title="ADD BRAND" />
              </button>
            </div>
          </SalesCatalystBoxInput>
        </div>
      </SalesCatalystTargetMarketInput>
    );
  }

  renderComponentWithCategory = (dataSelection, dataOnScreen) => {
    let categoryDetails;
    if (!_.isEmpty(dataSelection.category)) {
      categoryDetails = dataSelection.category;
    }
    return (
      <SalesCatalystTargetMarketInput
        color={this.props.color}
        className={'large-2 medium-2 small-2 columns col-half-offset'}
      >
        <div className="large-2 medium-2 small-2 columns col-half-offset">
          <SalesCatalystBoxInput
            defaultHeader={'BRAND'}
            data={dataSelection.brand[0]}
            deleteHandler={this.deleteHandler}
            subCategory={'brand'}
            field={'dataSelection'}
            index={0}
            backgroundColor={getBackGroundColor(dataSelection.brand[0],
              dataOnScreen.mediaPackage, 'BRAND')}
            color={getTextColor(dataSelection.brand[0],
              dataOnScreen.mediaPackage)}
            dataOnScreen={dataOnScreen.mediaPackage}
            showEditButton={false}
          />
        </div>
        <div
          className="large-4 medium-4 small-4 columns col-half-offset"
          style={{ float: 'left' }}
        >
          <SalesCatalystBoxInput
            defaultHeader={'CATEGORY'}
            data={formCategoryData(categoryDetails)}
            deleteHandler={this.deleteHandler}
            subCategory={'category'}
            field={'dataSelection'}
            index={0}
            backgroundColor={getBackGroundColor(categoryDetails,
              dataOnScreen.mediaPackage, 'CATEGORY')}
            color={getTextColor(categoryDetails,
              dataOnScreen.mediaPackage)}
            dataOnScreen={dataOnScreen.mediaPackage}
            showEditButton={false}
            showDeleteButton={false}
          />
        </div>
      </SalesCatalystTargetMarketInput>
    );
  }

  render() {
    const { dataSelection, dataOnScreen } = this.props;
    return (
      <div>
        {(this.state.renderInitialScreen && !this.state.showBrandSearchBox) &&
          this.renderComponentWithOutCategory(dataSelection, dataOnScreen)
        }
        {(!this.state.renderInitialScreen && !this.state.showBrandSearchBox) &&
          this.renderComponentWithCategory(dataSelection, dataOnScreen)
        }
        {(this.state.showBrandSearchBox) &&
          this.renderBrandSerachBox()
        }
      </div>
  );
  }
}

SalesCatalystMediaPackageInput.propTypes = {
  dataSelection: PropTypes.arrayOf(PropTypes.object),
  deleteSalasCatalystSelection: PropTypes.func,
  categoryLabel: PropTypes.string,
  loadMediaPackageGarph: PropTypes.bool,
  fetchBrandCategory: PropTypes.func,
  fetchBrandDetails: PropTypes.func,
  searchBrand: PropTypes.fun,
  loadTargetMarketGarph: PropTypes.bool,
  resetOverlapWeighted: PropTypes.func,
  getEntityTargetOverlapWeighted: PropTypes.func,
  dataOnScreen: PropTypes.shape({}),
  renderInitialScreen: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
    dataSelection: state.salesCatalyst.dataSelection,
    loadMediaPackageGarph: state.salesCatalyst.dataOnScreen.mediaPackage,
    salesCatalystStudy: state.study.salesCatalystStudy,
    categoryLabel: (!_.isEmpty(state.salesCatalyst.dataSelection.category)) ?
      state.salesCatalyst.dataSelection.category.categoryLabel : '',
    salesCatalystBase: state.salesCatalyst.salesCatalystBase,
    dataOnScreen: state.salesCatalyst.dataOnScreen,
    loadTargetMarketGarph: state.salesCatalyst.dataOnScreen.targetMarket,
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const deleteSalasCatalystSelection = (mainCategory, subCategory, section) => {
    dispatch(salesCatalystActions.deleteSalesCatalystSelection(mainCategory, subCategory, section));
    dispatch(salesCatalystActions.resetGraphData(subCategory));
    dispatch(salesCatalystActions.resetMediaPackagecategory());
  };

  const fetchBrandDetails = brand => {
    // const headerInfo = getHeaderInfo(brand);
    const expressionList = [];
    expressionList.push(brand.value);
    const personaLabel = [];
    personaLabel.push(brand.label);
    const productNo = stateProps.salesCatalystStudy.pn;
    const token = stateProps.loginResponse.data.token;
    const uid = stateProps.loginResponse.data.uid;
    const accountId = stateProps.activeAccountId;
    const textInputFlag = true;
    const headerInfo = {};
    headerInfo.expression = expressionList;
    headerInfo.label = personaLabel;

    dispatch(salesCatalystActions.getSalesHeaderInfo(
      token,
      uid,
      accountId,
      headerInfo,
      SALES_CATALYST_HEADERINFO_REPORT_NAME,
      productNo,
      textInputFlag,
    )).then(response => {
      if (response.status === 200) {
        const brandDetails = [];
        const data = response.data[0].headers[1];
        data.expression = brand.value;
        brandDetails.push(data);
        dispatch(salesCatalystActions.setBrandSampleDetails(brandDetails));
      }
    });
  };

  const fetchBrandCategory = brand => {
    const productNo = stateProps.salesCatalystStudy.pn;
    const divisor = stateProps.salesCatalystStudy.dv;
    const weightType = stateProps.salesCatalystStudy.wt === 3 ? 1
      : stateProps.salesCatalystStudy.wt;
    const token = stateProps.loginResponse.data.token;
    const uid = stateProps.loginResponse.data.uid;
    const accountId = stateProps.activeAccountId;
    const brandExpression = brand.expression;
    dispatch(salesCatalystActions.fetchBrandCategory({
      uid,
      accountId,
      token,
      brandExpression,
      productNo,
      divisor,
      weightType,
    }));
  };

  const searchBrand = (searchText, resolve) => {
    const token = stateProps.loginResponse.data.token;
    const uid = stateProps.loginResponse.data.uid;
    const accountId = stateProps.activeAccountId;
    const productNo = stateProps.salesCatalystStudy.pn;
    dispatch(salesCatalystActions.searchBrand({
      uid,
      accountId,
      token,
      searchText,
      productNo,
      resolve,
    }));
  };

  return Object.assign({}, stateProps, ownProps, {
    deleteSalasCatalystSelection,
    fetchBrandDetails,
    fetchBrandCategory,
    searchBrand,
  });
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystMediaPackageInput);
